import { UserSettingsRoutes } from '@/routes/user/settings'

export const tenDlcRouteNamespace = 'tenDlc'

export const tollFreeRouteNamespace = 'tollFree'
export type TenDlcTollFreeRouteNamespace = typeof tenDlcRouteNamespace | typeof tollFreeRouteNamespace

export enum TenDlcTollFreeRoutes {
  base = 'usaFlow',
  chooseNumber = 'usaFlow.chooseNumber',
  tenDlcBase = `usaFlow.${tenDlcRouteNamespace}.base`,
  tenDlcInfo = `usaFlow.${tenDlcRouteNamespace}.info`,
  tenDlcRegisterBrand = `usaFlow.${tenDlcRouteNamespace}.registerBrand`,
  tenDlcRegisterCampaign = `usaFlow.${tenDlcRouteNamespace}.registerCampaign`,
  tenDlcSelectCampaign = `usaFlow.${tenDlcRouteNamespace}.selectCampaign`,
  tenDlcAutoFillCampaign = `usaFlow.${tenDlcRouteNamespace}.autoFillCampaign`,
  tenDlcSummary = `usaFlow.${tenDlcRouteNamespace}.summary`,
  tenDlcSuccess = `usaFlow.${tenDlcRouteNamespace}.success`,
  tenDlcSmsPrivacyPolicy = `usaFlow.${tenDlcRouteNamespace}.smsPrivacyPolicy`,
  tenDlcSmsTerms = `usaFlow.${tenDlcRouteNamespace}.smsTerms`,
  tollFreeBase = `usaFlow.${tollFreeRouteNamespace}.base`,
  tollFreeInfo = `usaFlow.${tollFreeRouteNamespace}.info`,
  tollFreeRegisterBrand = `usaFlow.${tollFreeRouteNamespace}.registerBrand`,
  tollFreeRegisterCampaign = `usaFlow.${tollFreeRouteNamespace}.registerCampaign`,
  tollFreeSummary = `usaFlow.${tollFreeRouteNamespace}.summary`,
  tollFreeSuccess = `usaFlow.${tollFreeRouteNamespace}.success`,
}

// @deprecated('Use UserSettingsRoutes instead')
export const ChatSettingsRoutes = {
  root: 'user.chats.settings',
  smsGeneral: 'user.chats.settings.sms.general',
  smsMmsCalls: 'user.chats.settings.smsMmsCalls',
  smsMmsCallsNumbers: 'user.chats.settings.smsMmsCalls.numbers',
  smsMmsCallsSenderIds: 'user.chats.settings.smsMmsCalls.senderIds',
  smsMmsCallsBuyNumberBase: 'user.chats.settings.smsMmsCalls.buyNumberBase',
  smsMmsCallsBuyNumber: 'user.chats.settings.smsMmsCalls.buyNumber',
  smsMmsCallsCallForwarding: 'user.chats.settings.smsMmsCalls.callForwarding',
  widgetPreview: 'user.chats.settings.web-widget.preview',
  tenDlc: 'user.chats.settings.10dlc',
  tollFree: 'user.chats.settings.tollFree',
  senderSettings: 'user.chats.settings.senderSettings',
} as const

export const enum ChatSettingsAliasedRoutes {
  buyNumber = '/messenger/settings/sms-mms-calls/numbers/buy-number',
  buyNumberNumber = '/messenger/settings/sms-mms-calls/numbers/buy-number/number',
  buyNumberForwarding = '/messenger/settings/sms-mms-calls/numbers/buy-number/call-forwarding/:id',

  complianceRoot = '/messenger/settings/sms-mms-calls/buy-number/compliance',
  complianceChooseNumber = '/messenger/settings/sms-mms-calls/buy-number/compliance/choose-number',

  complianceTenDlcInfo = `${ChatSettingsAliasedRoutes.complianceRoot}/10dlc/info/:id`,
  complianceTenDlcRegisterBrand = `${ChatSettingsAliasedRoutes.complianceRoot}/10dlc/register-brand/:id`,
  complianceTenDlcRegisterCampaign = `${ChatSettingsAliasedRoutes.complianceRoot}/10dlc/register-campaign/:id`,
  complianceTenDlcSelectCampaign = `${ChatSettingsAliasedRoutes.complianceRoot}/10dlc/select-campaign/:id`,
  complianceTenDlcSummary = `${ChatSettingsAliasedRoutes.complianceRoot}/10dlc/summary/:id`,
  complianceTenDlcSuccess = `${ChatSettingsAliasedRoutes.complianceRoot}/10dlc/success`,
  complianceTenDlcSenderSettings = '/messenger/settings/10dlc/campaign/:campaignId',
  complianceTenDlcSenderSettingsNumbers = '/messenger/settings/10dlc/campaign/:campaignId/numbers',

  complianceTollFreeInfo = `${ChatSettingsAliasedRoutes.complianceRoot}/toll-free/info/:id`,
  complianceTollFreeRegisterBrand = `${ChatSettingsAliasedRoutes.complianceRoot}/toll-free/register-brand/:id`,
  complianceTollFreeRegisterCampaign = `${ChatSettingsAliasedRoutes.complianceRoot}/toll-free/register-campaign/:id`,
  complianceTollFreeSummary = `${ChatSettingsAliasedRoutes.complianceRoot}/toll-free/summary/:id`,
  complianceTollFreeSuccess = `${ChatSettingsAliasedRoutes.complianceRoot}/toll-free/success`,
}

export const tenDlcTollFreeRouteNames = [
  TenDlcTollFreeRoutes.base,
  TenDlcTollFreeRoutes.chooseNumber,
  TenDlcTollFreeRoutes.tollFreeBase,
  TenDlcTollFreeRoutes.tollFreeRegisterBrand,
  TenDlcTollFreeRoutes.tollFreeRegisterCampaign,
  TenDlcTollFreeRoutes.tollFreeSummary,
  TenDlcTollFreeRoutes.tollFreeSuccess,
  TenDlcTollFreeRoutes.tenDlcBase,
  TenDlcTollFreeRoutes.tenDlcInfo,
  TenDlcTollFreeRoutes.tenDlcRegisterBrand,
  TenDlcTollFreeRoutes.tenDlcRegisterCampaign,
  TenDlcTollFreeRoutes.tenDlcSelectCampaign,
  TenDlcTollFreeRoutes.tenDlcSummary,
  TenDlcTollFreeRoutes.tenDlcSuccess,
  UserSettingsRoutes.SmsVoiceTenDlc,
  UserSettingsRoutes.SmsVoiceTollFree,
  ChatSettingsAliasedRoutes.complianceRoot,
  ChatSettingsAliasedRoutes.complianceChooseNumber,
  ChatSettingsAliasedRoutes.complianceTenDlcInfo,
  ChatSettingsAliasedRoutes.complianceTenDlcRegisterBrand,
  ChatSettingsAliasedRoutes.complianceTenDlcRegisterCampaign,
  ChatSettingsAliasedRoutes.complianceTenDlcSelectCampaign,
  ChatSettingsAliasedRoutes.complianceTenDlcSummary,
  ChatSettingsAliasedRoutes.complianceTenDlcSuccess,
  ChatSettingsAliasedRoutes.complianceTenDlcSenderSettings,
  ChatSettingsAliasedRoutes.complianceTenDlcSenderSettingsNumbers,
  ChatSettingsAliasedRoutes.complianceTollFreeInfo,
  ChatSettingsAliasedRoutes.complianceTollFreeRegisterBrand,
  ChatSettingsAliasedRoutes.complianceTollFreeRegisterCampaign,
  ChatSettingsAliasedRoutes.complianceTollFreeSummary,
  ChatSettingsAliasedRoutes.complianceTollFreeSuccess,
]
